import React from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'

const MetarDetailPressure = props => {
  return (
    <MetarDetailSection
      title={"PRESSURE"}
    >
      <MetarDetailSectionItem
        header={"ALTIMETER"}
        value={props.altimeter}
        footer={"\xA0"}
      />
    </MetarDetailSection>
  )
}

export default MetarDetailPressure



// WEBPACK FOOTER //
// ./src/components/MetarDetailPressure.js